var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClioCreditLibrary(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "18px",
    viewBox: "0 0 12 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Credit Database") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "All-Icons",
    transform: "translate(-179.000000, -6.000000)",
    stroke: "#B7844D",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Credit-Database",
    transform: "translate(180.941125, 6.485365)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3",
    points: "0 8.89709727 8 8.89709727 4 16"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 4.02553005,
    cy: 3.51420843,
    rx: 2.80579699,
    ry: 2.86420843
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClioCreditLibrary);
export default __webpack_public_path__ + "static/media/ClioCreditLibrary.bdb5ab416a7d38e7c8a97c97b5251b8e.svg";
export { ForwardRef as ReactComponent };